<template>
    <v-navigation-drawer
        right
        fixed
        v-model="drawer"
        :width="drawerWidth"
        app
        class="resizable-drawer"
        :class="{ 'no-transition-on-resize': isResizing }"
    >
        <v-toolbar flat dense>
            <v-btn icon @click="handleHomeButton">
                <v-icon>mdi-home-search</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('update:help', false)">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-tabs v-model="activeTab" grow color="basil" :background-color="$vuetify.theme.dark ? '#272727' : '#fff'">
            <v-tabs-slider color="#1976d2"></v-tabs-slider>
            <v-tab v-for="tab in tabs" :key="tab.value" :value="tab.value">
                <v-icon left class="mr-4">{{ tab.icon }}</v-icon>
                {{ tab.name }}
            </v-tab>
        </v-tabs>

        <div v-if="activeTab === 1">
            <iframe
                :src="chatBotUrl"
                width="100%"
                frameborder="0"
                class="main-help-iframe"
                @load="loading = false"
            ></iframe>
        </div>
        <div v-if="activeTab === 0">
            <iframe
                v-if="helpCenterUrl"
                :key="helpKey"
                :src="helpCenterUrl"
                class="main-help-iframe"
                @load="loading = false"
            ></iframe>
        </div>
        <div v-if="loading" class="loader-wrapper">
            <v-progress-circular :size="50" :width="4" color="primary" indeterminate />
        </div>
        <div v-if="isResizing" class="iframe-overlay"></div>

        <div class="resizer" @mousedown="startResize"></div>
    </v-navigation-drawer>
</template>

<script>
import store from "@/store";
import { mapGetters, mapMutations } from "vuex";
export default {
    name: "HelpCenterSideBar",
    props: {
        help: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            drawerWidth: 400,
            minWidth: 300,
            maxWidth: 900,
            isResizing: false,
            startX: 0,
            startWidth: 0,
            helpCenterUrl: "",
            loading: true,
            helpKey: 0,
            activeTab: 0,
            chatBotUrl: "",
            tabs: [
                { name: "Help Center", icon: "mdi-help-circle", value: "help-center" },
                { name: "Chat", icon: "mdi-face-agent", value: "chat" },
            ],
        };
    },
    computed: {
        ...mapGetters("settings", ["settings"]),
        drawer: {
            get() {
                return this.help;
            },
            set(val) {
                this.$emit("update:help", val);
            },
        },
    },
    methods: {
        ...mapMutations("settings", ["setHelpSidebarWidth"]),
        // Called on mousedown to start resizing the drawer
        startResize(e) {
            this.isResizing = true;
            this.startX = e.clientX;
            this.startWidth = this.drawerWidth;

            document.addEventListener("mousemove", this.doResize);
            document.addEventListener("mouseup", this.stopResize);

            document.body.style.cursor = "ew-resize";

            document.body.classList.add("no-select");
        },

        // Called on mousemove to calculate and apply new width
        doResize(moveEvent) {
            if (!this.isResizing) return;
            const dx = this.startX - moveEvent.clientX;
            let newWidth = this.startWidth + dx;
            this.drawerWidth = Math.max(this.minWidth, Math.min(this.maxWidth, newWidth));
        },

        // Called on mouseup to end resizing and remove listeners
        stopResize() {
            this.isResizing = false;
            this.setHelpSidebarWidth(this.drawerWidth);
            this.cleanupResizeListeners();
        },
        // Cleanup listeners and cursor override
        cleanupResizeListeners() {
            document.removeEventListener("mousemove", this.doResize);
            document.removeEventListener("mouseup", this.stopResize);
            document.body.style.cursor = "";
            document.body.classList.remove("no-select");
        },
        // Navigating helpcenter tab when click on the home button
        handleHomeButton() {
            if (this.activeTab == 0) this.helpKey++;
            else this.activeTab = 0;
        },
    },
    watch: {
        helpKey() {
            this.loading = true;
        },
        activeTab() {
            this.loading = true;
        },
    },

    // Clean up listeners and cursor override if component is destroyed
    beforeDestroy() {
        this.cleanupResizeListeners();
    },
    mounted() {
        this.helpCenterUrl = store.state.api.helpCenterUrl;
        this.chatBotUrl = store.state.api.chatBotUrl;
        this.loading = true;
        const saved = this.settings.helpSidebarWidth;
        const maxSafe = window.innerWidth * 0.5; // 50% of viewport
        this.drawerWidth = Math.min(saved, maxSafe);
    },
};
</script>

<style scoped lang="scss" src="./HelpCenterSidebar.style.scss" />
